import Vue from "vue";

const HANDLERS = new WeakMap();

const observer = new IntersectionObserver(
  (entries) => {
    for (const entry of entries) {
      if (HANDLERS.has(entry.target)) {
        const handler = HANDLERS.get(entry.target);
        handler(entry); // Pass the full entry to the handler
      }
    }
  },
  {
    // Add a small rootMargin to trigger a bit before it's fully in view
    rootMargin: "0px 0px -50px 0px",
    threshold: 0,
  }
);

Vue.directive("in-view", {
  bind(el, binding) {
    HANDLERS.set(el, binding.value);
    observer.observe(el);
  },
  unbind(el) {
    HANDLERS.delete(el);
    observer.unobserve(el);
  },
});
